export default __webpack_public_path__ + "static/media/poweredlsitec.ffbe30bf.png";